export default __webpack_public_path__ + "static/media/img1.04c3e28f.jpg";